export const transactionResourceUrl = 'transactions';
export const costSettingsResourceUrl = 'cost-settings';
